<template>
  <!-- Main Sidebar -->
  <a-layout-sider
    collapsible
    class="sider-primary"
    breakpoint="lg"
    collapsed-width="0"
    width="250px"
    :collapsed="sidebarCollapsed"
    @collapse="$emit('toggleSidebar', !sidebarCollapsed)"
    :trigger="null"
    :class="[
      'ant-layout-sider-' + sidebarColor,
      'ant-layout-sider-' + sidebarTheme,
    ]"
    theme="light"
    :style="{ backgroundColor: 'transparent' }"
  >
    <div class="brand">
      <a href="https://wc.sn9527.com/KnowledgeBase/" target="_blank" rel="noopener noreferrer">
        <img src="images/logo-ct-black.png" alt="" /> <span>Tyean</span>
      </a>
    </div>
    <hr />

    <!-- Sidebar Navigation Menu -->
    <a-menu theme="light" mode="inline">
      <a-menu-item v-for="(item, index) in routers" :key="index">
        <router-link :to="item.path" v-show="!item.hidden">
          <span class="icon">
            <svg-icon :icon-class="item.meta.icon" />
          </span>
          <span class="label">{{item.meta.title}}</span>
        </router-link>
      </a-menu-item>
    </a-menu>
    <!-- / Sidebar Navigation Menu -->
  </a-layout-sider>
  <!-- / Main Sidebar -->
</template>

<script>
import store from '@/store'
export default {
  props: {
    // Sidebar collapsed status.
    sidebarCollapsed: {
      type: Boolean,
      default: false,
    },

    // Main sidebar color.
    sidebarColor: {
      type: String,
      default: "primary",
    },

    // Main sidebar theme : light, white, dark.
    sidebarTheme: {
      type: String,
      default: "light",
    },
  },
  data() {
    return {
      // sidebarCollapsedModel: this.sidebarCollapsed,
      routers: store.getters.permission_routes,
    };
  },
  methods: {
    getRouters() {
      
    }
  },
};
</script>

<style lang="scss">
.icon {
  color: #bfbfbf;
}

.router-link-active {
  .icon {
    color: #ffffff;
  }
}
.brand a {
  color: #000000;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
